import React from 'react';
import { Link } from 'react-router-dom';
import { Models } from 'appwrite';
import { useAuth } from '../../contexts/AuthContext';

const Header: React.FC = () => {
  const { user, logout } = useAuth();

  return (
    <nav className="bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex space-x-8">
            <Link to="/" className="flex items-center">
              <span className="text-xl font-bold text-primary-600">校园连接</span>
            </Link>
            <div className="hidden sm:flex sm:space-x-8">
              <Link to="/community" className="text-gray-600 hover:text-primary-600 flex items-center">
                社区
              </Link>
              <Link to="/jobs" className="text-gray-600 hover:text-primary-600 flex items-center">
                职位
              </Link>
              <Link to="/talent" className="text-gray-600 hover:text-primary-600 flex items-center">
                人才库
              </Link>
              <Link to="/news" className="text-gray-600 hover:text-primary-600 flex items-center">
                新闻
              </Link>
              <Link to="/card-analysis" className="text-gray-600 hover:text-primary-600 flex items-center">
                名片分析
              </Link>
            </div>
          </div>
          <div className="flex items-center space-x-4">
            {user ? (
              <div className="flex items-center space-x-4">
                <Link to={`/profile/${user.id}`} className="text-gray-600 hover:text-primary-600">
                  {user.email} {user.id.slice(0,5)}
                </Link>
                <button 
                  onClick={() => logout()} 
                  className="text-gray-600 hover:text-primary-600"
                >
                  退出
                </button>
              </div>
            ) : (
              <>
                <Link to="/login" className="text-gray-600 hover:text-primary-600">
                  登录
                </Link>
                <Link to="/register" className="bg-primary-500 text-white px-4 py-2 rounded-md hover:bg-primary-600">
                  注册
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;    